// Copyright (c) 2016 Deere & Company

import ClaimAction, {getDefaultState as getClaimActionDefaultState} from './claim-action';
import ClaimComplaintCause, {getDefaultState as getClaimComplaintCauseDefaultState} from './claim-complaint-cause';
import ClaimFailureInfo, {getDefaultState as getClaimFailureInfoDefaultState} from './claim-failure-info';
import ClaimRecordInfo, {getDefaultState as getClaimClaimRecordInfoDefaultState} from './claim-record-info';
import ClaimReferenceInfo, {getDefaultState as getClaimReferenceInfoDefaultState} from './claim-reference-info';
import ClaimReimbursementDetails, {getDefaultState as getClaimReimbursementDetailsDefaultState} from './claim-reimbursement-details';
import ClaimRgaStatus, {getDefaultState as getClaimRgaStatusDefaultState} from './claim-rga-status';
import ClaimRules, {getDefaultState as getClaimRulesDefaultState} from './claim-rules';
import ClaimValueDetails, {getDefaultState as getClaimValueDetailsDefaultState} from './claim-value-details';
import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import ClaimAdditionalFailureInfo from './claim-additional-failure-info';
import ClaimItemPart from './claim-item-part';
import ClaimLabor from './claim-item-labor';
import ClaimOtherCredit from './claim-item-other-credit';
import ClaimVsrMessage from './claim-vsr-message';
import File from './file';
import t from 'tcomb';

const ClaimAttachment = t.struct({
    additionalFailureInfo: ClaimAdditionalFailureInfo,
    allowedActions: t.list(ClaimAction, 'AllowedActions'),
    claimNumber: t.String,
    claimStatus: KeyValuePair,
    claimType: KeyValuePair,
    claimValueDetails: ClaimValueDetails,
    complaintCauseCommentsBasis: ClaimComplaintCause,
    errors: t.list(ClaimVsrMessage, 'Errors'),
    failureInfo: ClaimFailureInfo,
    file: t.maybe(t.list(File, 'Files')),
    goodsInstallationVat: t.maybe(KeyValuePair),
    hideClaimValueDetails: t.Bool,
    isDuplicateClaim: t.Bool,
    isEditable: t.Bool,
    itemNumber: t.String,
    labor: t.maybe(t.list(ClaimLabor, 'Labor')),
    otherCredits: t.maybe(t.list(ClaimOtherCredit, 'OtherCredits')),
    parts: t.maybe(t.list(ClaimItemPart, 'Parts')),
    previousInvoiceNumber: t.String,
    recordInfo: ClaimRecordInfo,
    referenceInfo: ClaimReferenceInfo,
    reimbursementDetails: ClaimReimbursementDetails,
    responsibleAccount: Dealer,
    retailInstallDate: t.maybe(t.Number),
    rgaStatus: ClaimRgaStatus,
    rules: ClaimRules,
    selectedAction: ClaimAction,
    showAmountsInLocalCurrency: t.Bool,
    showGoodsInstallationVat: t.Bool,
    showValidate: t.Bool,
    validationFailed: t.Bool,
    version: t.String
}, {
    name: 'ClaimAttachment',
    strict: true
});

export const getDefaultState = () => new ClaimAttachment({
    additionalFailureInfo: new ClaimAdditionalFailureInfo({
        downtime: getKeyValuePairDefaultState(),
        dtacCase: '',
        dtacSolution: '',
        failureArea: '',
        failureMode: getKeyValuePairDefaultState(),
        failureModeComments: ''
    }),
    allowedActions: [
        new ClaimAction({
            actionName: 'DRAFT',
            id: 'DRAFT',
            mode: 'CHG'
        })
    ],
    claimNumber: '',
    claimStatus: getKeyValuePairDefaultState(),
    claimType: new KeyValuePair({
        key: 'ZZNS',
        value: ''
    }),
    claimValueDetails: getClaimValueDetailsDefaultState(),
    complaintCauseCommentsBasis: getClaimComplaintCauseDefaultState(),
    errors: [],
    failureInfo: getClaimFailureInfoDefaultState(),
    file: [],
    goodsInstallationVat: getKeyValuePairDefaultState(),
    hideClaimValueDetails: false,
    isDuplicateClaim: false,
    isEditable: true,
    itemNumber: '',
    labor: [],
    otherCredits: [],
    parts: [],
    previousInvoiceNumber: '',
    recordInfo: getClaimClaimRecordInfoDefaultState(),
    referenceInfo: getClaimReferenceInfoDefaultState(),
    reimbursementDetails: getClaimReimbursementDetailsDefaultState(),
    responsibleAccount: getDealerDefaultState(),
    retailInstallDate: null,
    rgaStatus: getClaimRgaStatusDefaultState(),
    rules: getClaimRulesDefaultState(),
    selectedAction: getClaimActionDefaultState(),
    showAmountsInLocalCurrency: false,
    showGoodsInstallationVat: false,
    showValidate: true,
    validationFailed: false,
    version: ''
});

ClaimAttachment.prototype.vsrErrorMessages = function vsrErrorMessages() {

    const errorMessages = this.errors.filter(vsrMessage => vsrMessage.type.key === 'E');

    return errorMessages;

};

ClaimAttachment.prototype.vsrWarningMessages = function vsrWarningMessages() {

    const errorMessages = this.errors.filter(vsrMessage => vsrMessage.type.key === 'W');

    return errorMessages;

};

ClaimAttachment.prototype.vsrInfoMessages = function vsrInfoMessages() {

    const errorMessages = this.errors.filter(vsrMessage => vsrMessage.type.key === 'I');

    return errorMessages;

};

export default ClaimAttachment;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-attachment.js